import React from 'react';


function Footer() {
  return (
    <footer className="footer">
      <div className="footer-left">
        © IDX Exchange. All rights reserved.
      </div>
      <div className="footer-center">
        <a href="/privacy">Privacy</a> | <a href="/terms">Terms and Conditions</a>
      </div>
      {/* <div className="footer-right">
        <a href="#"><i className="fab fa-facebook-f"></i></a>
        <a href="#"><i className="fab fa-twitter"></i></a>
        <a href="#"><i className="fab fa-linkedin-in"></i></a>
        <a href="#"><i className="fab fa-google-plus-g"></i></a>
      </div> */}
    </footer>
  );
}

export default Footer;
